module.exports = __webpack_public_path__ + "static/img/head_service.71de7fc7.jpg";